import { Capacitor, registerPlugin } from '@capacitor/core';
import { toast } from 'sonner';

const MediaSaver = registerPlugin('MediaSaver');

export const canSaveDirectly = () =>
  Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('MediaSaver');

// Saves straight to Gallery (images) or Download/RVincente (other files).
// Returns false when the installed app build has no native saver (caller falls back to share).
export async function saveBase64ToDevice(base64, fileName, mimeType = 'image/png') {
  if (!canSaveDirectly()) return false;
  try {
    const res = await MediaSaver.saveFile({ base64, fileName, mimeType });
    const where = res?.location === 'downloads'
      ? 'Salvato in Download › RVincente'
      : (Capacitor.getPlatform() === 'ios' ? 'Salvata in Foto' : 'Salvata nella Galleria › RVincente');
    toast.success(where);
    return true;
  } catch (e) {
    console.warn('[deviceSave] native save failed:', e?.message);
    return false;
  }
}

export const blobToBase64 = (blob) => new Promise((resolve, reject) => {
  const r = new FileReader();
  r.onload = () => resolve(String(r.result).split(',')[1]);
  r.onerror = reject;
  r.readAsDataURL(blob);
});
